module.exports = __webpack_public_path__ + "img/button_next.76a59ab2.png";